// Node
const $ = require('jquery');
// require('owl.carousel/dist/owl.carousel');


const updateCounterText  = function (info, $elem) {
  let { // http://ganlanyuan.github.io/tiny-slider/#methods
    displayIndex,
    slideCount,
    cloneCount
  } = info;

  let totalSlides = slideCount - cloneCount * 2;
  let currentSlide =
    displayIndex > totalSlides
      ? displayIndex - cloneCount * 2
      : displayIndex
  ;

  if ($elem) {
    $elem.html(`${currentSlide}/${totalSlides}`);
  }
};

const handleMiniSliderOpen = function ($slider, sliderTns) {
  let $sliderPopup = $slider.closest('.popup');

  if ($sliderPopup) {
    let sliderPopupId = $sliderPopup.attr('id');
    let $sliderOpeners = $(`[data-nav][rel=${sliderPopupId}]`);

    $sliderOpeners.each(function () {
      let $sliderOpener = $(this);
      $sliderOpener.on('click', function () {
        sliderTns.goTo($sliderOpener.data('nav'));
      });
    });
  }
};

// const sliderCardInit = function() {
//   let cardSlider = $('.card__thumb-slider');
//
//   cardSlider.each(function () {
//     let cardSlider = $(this);
//
//     if (cardSlider.hasClass('owl-loaded')) {
//       return;
//     }
//
//     cardSlider.owlCarousel({
//       loop: true,
//       margin: 2,
//       nav: false,
//       dots: true,
//       items: 1,
//     });
//
//     let next = cardSlider.parent().find('.card__thumb-arrow-next'),
//       prev = cardSlider.parent().find('.card__thumb-arrow-prev');
//
//     next.on('click', function () {
//       cardSlider.trigger('next.owl.carousel');
//     });
//     prev.on('click', function () {
//       cardSlider.trigger('prev.owl.carousel', [300]);
//     });
//   });
// };

export {
  updateCounterText,
  handleMiniSliderOpen,
  // sliderCardInit
};
